<template lang="html">
  <div id="d-detail-template-1">
    <div class="box-white-s1">
      <div class="box-image">
        <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+ row.imageUrl +')' }"></div>
      </div>

      <div class="basic-info">
        <h1 class="title">{{row.name}}</h1>
      </div>

      <div class="box-description">
        <p>{{ row.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        row:{},
        id:null,
    }
  },

  methods: {
   
    getRow(){
      axios.get(tools.url("/api/benefits/"+this.id)).then((response)=>{
          this.row = response.data;
      }).catch(()=>{});
    }
  },
  mounted(){
    this.id=this.$route.params.id;
      this.getRow();
  }
}
</script>
